var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4003 3.33986L13.6603 0.599858C13.3027 0.263954 12.8341 0.0712167 12.3436 0.0583099C11.8532 0.0454032 11.3751 0.213227 11.0003 0.529858L2.0003 9.52986C1.67706 9.85582 1.4758 10.2831 1.4303 10.7399L1.0003 14.9099C0.986826 15.0563 1.00583 15.204 1.05596 15.3422C1.10608 15.4805 1.1861 15.606 1.2903 15.7099C1.38374 15.8025 1.49455 15.8759 1.61639 15.9256C1.73823 15.9754 1.86869 16.0006 2.0003 15.9999H2.0903L6.2603 15.6199C6.71709 15.5744 7.14433 15.3731 7.4703 15.0499L16.4703 6.04986C16.8196 5.68083 17.0084 5.18837 16.9953 4.68039C16.9822 4.17242 16.7682 3.69037 16.4003 3.33986ZM13.0003 6.67986L10.3203 3.99986L12.2703 1.99986L15.0003 4.72986L13.0003 6.67986Z",
    fill: "#2979FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/PenIcon.a5e8ad87f1542d5ff90a76e4b381010c.svg";
export { ForwardRef as ReactComponent };